<template>
  <div
    v-if="version === 'v1'"
    class="n-card tw-relative tw-flex tw-w-full tw-flex-col tw-overflow-hidden tw-rounded-t-lg tw-bg-white tw-text-start md:tw-min-h-[620px]"
    style="border-radius: var(--rounded)"
  >
    <nuxt-link :external="true" :to="property.detail_page_url" class="n-link tw-group tw-relative">
      <LibraryImage 
        :src="property.image" 
        :h-ratio="10" 
        :w-ratio="16" 
        class="tw-overflow-hidden" 
        :blur="imageBlurFilter"
        :pre-market-blur-text="preMarketBlurText"/>
      <div v-if="property.custom_property_status_title" class="nc-property-image-badge">
        {{ property.custom_property_status_title }}
      </div>
      <div class="tw-flex tw-min-h-[520px] tw-flex-col tw-bg-white tw-p-4 sm:tw-p-10 lg:tw-p-6">
        <h4 class="tw-line-clamp-3 tw-h-[74px] hover:tw-line-clamp-none hover:tw-overflow-auto">
          {{ property.advert_heading }}
        </h4>
        <template v-if="!property.is_locked">
          <div class="tw-py-4">
          <p v-if="property.price.type.name">
            {{ property.price.type.name }}
          </p>
          <h4>{{ property.price.price }}</h4>
        </div>
        <div class="tw-flex tw-flex-row tw-items-center tw-gap-4 tw-py-4">
          <small class="tw-flex tw-items-center tw-gap-2 tw-whitespace-nowrap">
            <span
              ><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.1256 3.25H13.2376C15.0756 3.25 16.5316 3.25 17.6706 3.403C18.8426 3.561 19.7916 3.893 20.5406 4.641C21.2886 5.39 21.6206 6.339 21.7786 7.511C21.9296 8.637 21.9316 10.071 21.9316 11.879C22.2756 12.162 22.5486 12.529 22.7216 12.948C22.8426 13.238 22.8896 13.538 22.9116 13.855C22.9316 14.159 22.9316 14.53 22.9316 14.975V15.025C22.9316 15.47 22.9316 15.841 22.9116 16.145C22.8987 16.4557 22.8345 16.7622 22.7216 17.052C22.5836 17.3857 22.3811 17.689 22.1258 17.9445C21.8704 18.2 21.5673 18.4027 21.2336 18.541C20.9436 18.661 20.6436 18.708 20.3266 18.729C20.1951 18.7378 20.0634 18.7434 19.9316 18.746V20C19.9316 20.1989 19.8526 20.3897 19.712 20.5303C19.5713 20.671 19.3806 20.75 19.1816 20.75C18.9827 20.75 18.792 20.671 18.6513 20.5303C18.5107 20.3897 18.4316 20.1989 18.4316 20V18.75H5.93164V20C5.93164 20.1989 5.85262 20.3897 5.71197 20.5303C5.57132 20.671 5.38055 20.75 5.18164 20.75C4.98273 20.75 4.79196 20.671 4.65131 20.5303C4.51066 20.3897 4.43164 20.1989 4.43164 20V18.745C4.29987 18.7428 4.16816 18.7374 4.03664 18.729C3.72602 18.7167 3.41956 18.6532 3.12964 18.541C2.7958 18.4028 2.49246 18.2002 2.23697 17.9447C1.98148 17.6892 1.77885 17.3858 1.64064 17.052C1.52064 16.762 1.47364 16.462 1.45264 16.145C1.43164 15.841 1.43164 15.47 1.43164 15.025V14.975C1.43164 14.53 1.43164 14.159 1.45164 13.855C1.47364 13.537 1.52164 13.238 1.64164 12.948C1.81346 12.5321 2.08472 12.1647 2.43164 11.878C2.43164 10.072 2.43364 8.637 2.58464 7.511C2.74264 6.339 3.07464 5.39 3.82264 4.641C4.57164 3.893 5.52064 3.561 6.69264 3.403C7.83264 3.25 9.28764 3.25 11.1256 3.25ZM3.93164 11.279C4.26452 11.2575 4.59807 11.2478 4.93164 11.25V10.448C4.93164 9.55 4.93164 8.8 5.01164 8.206C5.09564 7.578 5.28164 7.011 5.73664 6.556C6.19264 6.1 6.75964 5.914 7.38664 5.83C7.98164 5.75 8.73164 5.75 9.62964 5.75H14.7336C15.6326 5.75 16.3816 5.75 16.9756 5.83C17.6036 5.914 18.1706 6.1 18.6256 6.555C19.0816 7.011 19.2676 7.578 19.3516 8.205C19.4316 8.8 19.4316 9.55 19.4316 10.448V11.25C19.7652 11.2478 20.0988 11.2575 20.4316 11.279C20.4286 9.744 20.4116 8.604 20.2916 7.711C20.1566 6.705 19.9026 6.125 19.4796 5.701C19.0566 5.279 18.4766 5.025 17.4706 4.89C16.4436 4.752 15.0886 4.75 13.1816 4.75H11.1816C9.27464 4.75 7.92064 4.752 6.89164 4.89C5.88664 5.025 5.30664 5.279 4.88364 5.702C4.46064 6.125 4.20664 6.705 4.07164 7.711C3.95164 8.604 3.93464 9.744 3.93164 11.279ZM17.9316 11.25V10.5C17.9316 9.536 17.9296 8.888 17.8646 8.405C17.8026 7.944 17.6956 7.746 17.5646 7.616C17.4346 7.486 17.2376 7.379 16.7766 7.316C16.2936 7.252 15.6456 7.25 14.6816 7.25H12.9316V11.25H17.9316ZM11.4316 11.25V7.25H9.68164C8.71764 7.25 8.06964 7.252 7.58664 7.317C7.12564 7.379 6.92764 7.486 6.79764 7.617C6.66764 7.747 6.56064 7.944 6.49764 8.405C6.43364 8.888 6.43164 9.536 6.43164 10.5V11.25H11.4316ZM4.13864 12.767C3.89764 12.784 3.78064 12.813 3.70364 12.845C3.55184 12.9078 3.41392 12.9999 3.29775 13.1161C3.18159 13.2323 3.08946 13.3702 3.02664 13.522C2.99464 13.599 2.96564 13.716 2.94864 13.957C2.93164 14.204 2.93164 14.524 2.93164 15C2.93164 15.476 2.93164 15.796 2.94864 16.043C2.96564 16.284 2.99464 16.401 3.02664 16.478C3.15364 16.785 3.39664 17.028 3.70364 17.155C3.78064 17.187 3.89764 17.216 4.13864 17.233C4.38564 17.25 4.70564 17.25 5.18164 17.25H19.1816C19.6576 17.25 19.9776 17.25 20.2246 17.233C20.4656 17.216 20.5826 17.187 20.6596 17.155C20.9666 17.028 21.2096 16.785 21.3366 16.478C21.3686 16.401 21.3976 16.284 21.4146 16.043C21.4316 15.796 21.4316 15.476 21.4316 15C21.4316 14.524 21.4316 14.204 21.4146 13.957C21.3976 13.716 21.3686 13.599 21.3366 13.522C21.2738 13.3702 21.1817 13.2323 21.0655 13.1161C20.9494 12.9999 20.8114 12.9078 20.6596 12.845C20.5826 12.813 20.4656 12.784 20.2246 12.767C19.8772 12.7507 19.5294 12.745 19.1816 12.75H5.18164C4.70564 12.75 4.38564 12.75 4.13864 12.767Z"
                  fill="#6EADAB"
                />
              </svg> </span
            >{{ property.bedroom }}
            {{ property.bedroom > 1 ? 'Beds' : 'Bed' }}
          </small>
          <small class="tw-flex tw-items-center tw-gap-2 tw-whitespace-nowrap">
            <span
              ><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_11_2919)">
                  <path
                    d="M2.43164 13.125H20.4316V4.6875C20.4325 4.36975 20.3703 4.05498 20.2487 3.76142C20.1271 3.46786 19.9485 3.20133 19.7232 2.97727L19.7045 2.95852C19.3514 2.60594 18.898 2.37098 18.4064 2.28572C17.9148 2.20046 17.4088 2.26907 16.9576 2.48217C17.3837 3.19064 17.5608 4.02119 17.4608 4.84185C17.3607 5.66251 16.9893 6.4262 16.4055 7.01156L15.8922 7.52489L16.837 8.4698L15.7764 9.53039L14.8316 8.58553L9.59616 3.3502L8.6513 2.40534L9.71194 1.3447L10.6568 2.28956L11.1702 1.77623C11.7848 1.16336 12.5949 0.785558 13.4595 0.708671C14.324 0.631784 15.1881 0.860685 15.9012 1.35548C16.6532 0.8806 17.5443 0.675589 18.4282 0.774129C19.3121 0.87267 20.1362 1.2689 20.7651 1.89773L20.7838 1.91648C21.1489 2.27953 21.4383 2.71137 21.6353 3.18702C21.8323 3.66266 21.933 4.17266 21.9316 4.6875V13.125H23.4316V14.625H21.9316V16.0641C21.9317 16.185 21.9122 16.3051 21.8739 16.4198L20.4785 20.6057C20.4041 20.8298 20.2609 21.0248 20.0693 21.1629C19.8777 21.301 19.6475 21.3752 19.4114 21.375H18.8067L19.3535 23.25H17.791L17.2441 21.375H7.48945L6.92695 23.25H5.36133L5.92383 21.375H4.95211C4.71592 21.3752 4.48567 21.301 4.29406 21.1629C4.10246 21.0248 3.95924 20.8299 3.88477 20.6057L2.48948 16.4198C2.4512 16.3051 2.43167 16.185 2.43164 16.0641V14.625H0.931641V13.125H2.43164ZM15.3448 2.83687C14.9315 2.42453 14.3716 2.19295 13.7878 2.19295C13.204 2.19295 12.6441 2.42453 12.2308 2.83687L11.7176 3.3502L14.8314 6.46406L15.3448 5.95083C15.7571 5.53757 15.9887 4.97763 15.9887 4.39385C15.9887 3.81007 15.7571 3.25013 15.3448 2.83687ZM3.93164 16.0031L5.2222 19.875H19.1411L20.4316 16.0031V14.625H3.93164V16.0031Z"
                    fill="#6EADAB"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_11_2919">
                    <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24.1816 0)" />
                  </clipPath>
                </defs>
              </svg> </span
            >{{ property.bathroom }}
            {{ property.bathroom > 1 ? 'Baths' : 'Bath' }}
          </small>
          <small class="tw-flex tw-items-center tw-gap-2 tw-whitespace-nowrap">
            <span
              ><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_11_2923)">
                  <path
                    d="M21.1816 9V7C21.1816 5.35 19.8316 4 18.1816 4H14.1816C13.4116 4 12.7116 4.3 12.1816 4.78C11.6516 4.3 10.9516 4 10.1816 4H6.18164C4.53164 4 3.18164 5.35 3.18164 7V9C1.53164 9 0.181641 10.35 0.181641 12V17C0.181641 18.65 1.53164 20 3.18164 20V22H5.18164V20H19.1816V22H21.1816V20C22.8316 20 24.1816 18.65 24.1816 17V12C24.1816 10.35 22.8316 9 21.1816 9ZM14.1816 6H18.1816C18.7316 6 19.1816 6.45 19.1816 7V9.78C18.5716 10.33 18.1816 11.12 18.1816 12V14H13.1816V7C13.1816 6.45 13.6316 6 14.1816 6ZM5.18164 7C5.18164 6.45 5.63164 6 6.18164 6H10.1816C10.7316 6 11.1816 6.45 11.1816 7V14H6.18164V12C6.18164 11.12 5.79164 10.33 5.18164 9.78V7ZM22.1816 17C22.1816 17.55 21.7316 18 21.1816 18H3.18164C2.63164 18 2.18164 17.55 2.18164 17V12C2.18164 11.45 2.63164 11 3.18164 11C3.73164 11 4.18164 11.45 4.18164 12V16H20.1816V12C20.1816 11.45 20.6316 11 21.1816 11C21.7316 11 22.1816 11.45 22.1816 12V17Z"
                    fill="#6EADAB"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_11_2923">
                    <rect width="24" height="24" fill="white" transform="translate(0.181641)" />
                  </clipPath>
                </defs>
              </svg> </span
            >{{ property.reception }}
            {{ property.reception > 1 ? 'Receptions' : 'Reception' }}
          </small>
        </div>
        </template>
        <template v-else>
          <div class="tw-h-[136px] tw-flex tw-flex-col tw-justify-center">
            <h4>{{ preMarketBlurText || "Pre-market Property" }}</h4>
          </div>
        </template>
        <div class="tw-flex tw-h-8 tw-flex-row tw-items-center tw-gap-2">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10 11.25C9.38193 11.25 8.77775 11.0667 8.26384 10.7233C7.74994 10.38 7.3494 9.89191 7.11288 9.32089C6.87635 8.74987 6.81447 8.12154 6.93505 7.51534C7.05563 6.90915 7.35325 6.35233 7.79029 5.91529C8.22733 5.47825 8.78415 5.18063 9.39034 5.06005C9.99654 4.93947 10.6249 5.00135 11.1959 5.23788C11.7669 5.4744 12.255 5.87494 12.5983 6.38884C12.9417 6.90275 13.125 7.50693 13.125 8.125C13.124 8.9535 12.7945 9.74778 12.2086 10.3336C11.6228 10.9195 10.8285 11.249 10 11.25ZM10 6.25C9.62916 6.25 9.26665 6.35997 8.95831 6.566C8.64997 6.77202 8.40964 7.06486 8.26773 7.40747C8.12581 7.75008 8.08868 8.12708 8.16103 8.4908C8.23338 8.85451 8.41195 9.1886 8.67418 9.45083C8.9364 9.71305 9.27049 9.89163 9.63421 9.96397C9.99792 10.0363 10.3749 9.99919 10.7175 9.85728C11.0601 9.71536 11.353 9.47504 11.559 9.1667C11.765 8.85835 11.875 8.49584 11.875 8.125C11.8745 7.62787 11.6768 7.15125 11.3253 6.79972C10.9738 6.4482 10.4971 6.2505 10 6.25Z"
              fill="black"
            />
            <path
              d="M10 18.75L4.72751 12.5319C4.65425 12.4385 4.58174 12.3445 4.51001 12.25C3.60937 11.0636 3.12282 9.61452 3.12501 8.125C3.12501 6.30164 3.84934 4.55295 5.13865 3.26364C6.42796 1.97433 8.17664 1.25 10 1.25C11.8234 1.25 13.5721 1.97433 14.8614 3.26364C16.1507 4.55295 16.875 6.30164 16.875 8.125C16.8772 9.61384 16.3909 11.0623 15.4906 12.2481L15.49 12.25C15.49 12.25 15.3025 12.4963 15.2744 12.5294L10 18.75ZM5.50813 11.4969C5.50813 11.4969 5.65376 11.6894 5.68688 11.7306L10 16.8175L14.3188 11.7237C14.3463 11.6894 14.4925 11.4956 14.4931 11.495C15.2289 10.5257 15.6265 9.34189 15.625 8.125C15.625 6.63316 15.0324 5.20242 13.9775 4.14752C12.9226 3.09263 11.4918 2.5 10 2.5C8.50816 2.5 7.07742 3.09263 6.02253 4.14752C4.96764 5.20242 4.37501 6.63316 4.37501 8.125C4.3737 9.34265 4.77174 10.5271 5.50813 11.4969Z"
              fill="black"
            />
          </svg>
          <small class="tw-line-clamp-2">{{ property.display_address }}</small>
        </div>
        <template v-if="!property.is_locked">
          <div class="tw-flex tw-flex-col tw-gap-3 tw-py-4">
            <p
              v-for="(feature, index) in property.features.slice(0, featureCountNumber)"
              :key="`latestproperties-property-${index}-feature`"
              class="tw-flex tw-gap-3"
            >
              <span
                ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.5501 18.0001L3.8501 12.3001L5.2751 10.8751L9.5501 15.1501L18.7251 5.9751L20.1501 7.4001L9.5501 18.0001Z"
                    fill="#6EADAB"
                  />
                </svg>
              </span>
              {{ feature }}
            </p>
          </div>
        </template>
        <template v-else>
          <p class="tw-py-4">
          This is a pre-market property. You need to create an account and register to our property alerts in order to
          view it.
        </p>
        <div class="tw-mt-10 tw-flex tw-gap-x-2">
          <nuxt-link :to="routes.REGISTER" class="n-primary tw-w-fit" :external="true">Register</nuxt-link>
          <nuxt-link
            :to="`${routes.PROPERTY_DETAIL.replace(':propertyId', property.property_profile_id)}#login`"
            class="n-primary tw-w-fit"
            :external="true"
            >Login</nuxt-link
          >
        </div>
        </template>
      </div>
    </nuxt-link>
  </div>

  <div
    v-if="version === 'v2'"
    class="property-list-item card-box tw-flex tw-flex-col tw-px-5 tw-py-6 tw-text-start md:tw-min-h-[700px] md:tw-p-6"
    style="border-radius: var(--rounded); background-color: var(--c-card)"
  >
    <nuxt-link :external="true" :to="property.detail_page_url" class="n-link tw-group tw-relative">
      <div class="card-photo tw-relative">
        <LibraryImage
          :src="property.image"
          :h-ratio="10"
          :w-ratio="16"
          class="card-img tw-overflow-hidden"
          style="border-radius: var(--rounded)"
          :blur="imageBlurFilter"
          :pre-market-blur-text="preMarketBlurText"
        />
        <div
          v-if="property.custom_property_status_title"
          class="nc-property-image-badge"
          style="border-radius: var(--rounded)"
        >
          {{ property.custom_property_status_title }}
        </div>
      </div>
      <div class="tw-mt-5">
        <h5 class="n-title-primary tw-line-clamp-3 tw-h-[94px]">{{ property.advert_heading }}</h5>
      </div>
      <div class="tw-mt-5 tw-flex tw-h-8 tw-flex-row tw-items-center tw-gap-2">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10 11.25C9.38193 11.25 8.77775 11.0667 8.26384 10.7233C7.74994 10.38 7.3494 9.89191 7.11288 9.32089C6.87635 8.74987 6.81447 8.12154 6.93505 7.51534C7.05563 6.90915 7.35325 6.35233 7.79029 5.91529C8.22733 5.47825 8.78415 5.18063 9.39034 5.06005C9.99654 4.93947 10.6249 5.00135 11.1959 5.23788C11.7669 5.4744 12.255 5.87494 12.5983 6.38884C12.9417 6.90275 13.125 7.50693 13.125 8.125C13.124 8.9535 12.7945 9.74778 12.2086 10.3336C11.6228 10.9195 10.8285 11.249 10 11.25ZM10 6.25C9.62916 6.25 9.26665 6.35997 8.95831 6.566C8.64997 6.77202 8.40964 7.06486 8.26773 7.40747C8.12581 7.75008 8.08868 8.12708 8.16103 8.4908C8.23338 8.85451 8.41195 9.1886 8.67418 9.45083C8.9364 9.71305 9.27049 9.89163 9.63421 9.96397C9.99792 10.0363 10.3749 9.99919 10.7175 9.85728C11.0601 9.71536 11.353 9.47504 11.559 9.1667C11.765 8.85835 11.875 8.49584 11.875 8.125C11.8745 7.62787 11.6768 7.15125 11.3253 6.79972C10.9738 6.4482 10.4971 6.2505 10 6.25Z"
            fill="black"
          />
          <path
            d="M10 18.75L4.72751 12.5319C4.65425 12.4385 4.58174 12.3445 4.51001 12.25C3.60937 11.0636 3.12282 9.61452 3.12501 8.125C3.12501 6.30164 3.84934 4.55295 5.13865 3.26364C6.42796 1.97433 8.17664 1.25 10 1.25C11.8234 1.25 13.5721 1.97433 14.8614 3.26364C16.1507 4.55295 16.875 6.30164 16.875 8.125C16.8772 9.61384 16.3909 11.0623 15.4906 12.2481L15.49 12.25C15.49 12.25 15.3025 12.4963 15.2744 12.5294L10 18.75ZM5.50813 11.4969C5.50813 11.4969 5.65376 11.6894 5.68688 11.7306L10 16.8175L14.3188 11.7237C14.3463 11.6894 14.4925 11.4956 14.4931 11.495C15.2289 10.5257 15.6265 9.34189 15.625 8.125C15.625 6.63316 15.0324 5.20242 13.9775 4.14752C12.9226 3.09263 11.4918 2.5 10 2.5C8.50816 2.5 7.07742 3.09263 6.02253 4.14752C4.96764 5.20242 4.37501 6.63316 4.37501 8.125C4.3737 9.34265 4.77174 10.5271 5.50813 11.4969Z"
            fill="black"
          />
        </svg>
        <small>{{ property.display_address }}</small>
      </div>
      <template v-if="!property.is_locked">
        <div class="tw-mt-6">
        <p class="tw-mb-2">
          {{ property.price.type?.name || '\u00A0' }}
        </p>
        <h4>{{ property.price.price }}</h4>
      </div>

      <div class="tw-mt-6 tw-flex tw-flex-wrap tw-gap-x-6 tw-gap-y-3">
        <div v-if="property.bedroom">
          <small class="tw-flex tw-items-center tw-gap-2"
            ><span
              ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2 19V13C2 12.55 2.09167 12.1417 2.275 11.775C2.45833 11.4083 2.7 11.0833 3 10.8V8C3 7.16667 3.29167 6.45833 3.875 5.875C4.45833 5.29167 5.16667 5 6 5H10C10.3833 5 10.7417 5.071 11.075 5.213C11.4083 5.355 11.7167 5.55067 12 5.8C12.2833 5.55 12.5917 5.35433 12.925 5.213C13.2583 5.07167 13.6167 5.00067 14 5H18C18.8333 5 19.5417 5.29167 20.125 5.875C20.7083 6.45833 21 7.16667 21 8V10.8C21.3 11.0833 21.5417 11.4083 21.725 11.775C21.9083 12.1417 22 12.55 22 13V19H20V17H4V19H2ZM13 10H19V8C19 7.71667 18.904 7.47933 18.712 7.288C18.52 7.09667 18.2827 7.00067 18 7H14C13.7167 7 13.4793 7.096 13.288 7.288C13.0967 7.48 13.0007 7.71733 13 8V10ZM5 10H11V8C11 7.71667 10.904 7.47933 10.712 7.288C10.52 7.09667 10.2827 7.00067 10 7H6C5.71667 7 5.47933 7.096 5.288 7.288C5.09667 7.48 5.00067 7.71733 5 8V10ZM4 15H20V13C20 12.7167 19.904 12.4793 19.712 12.288C19.52 12.0967 19.2827 12.0007 19 12H5C4.71667 12 4.47933 12.096 4.288 12.288C4.09667 12.48 4.00067 12.7173 4 13V15Z"
                  fill="#074873"
                />
              </svg> </span
            >{{ property.bedroom }} Beds</small
          >
        </div>
        <div v-if="property.bathroom">
          <small class="tw-flex tw-items-center tw-gap-2"
            ><span
              ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7 6C7 5.73478 7.10536 5.48043 7.29289 5.29289C7.48043 5.10536 7.73478 5 8 5H9V6C9 6.26522 9.10536 6.51957 9.29289 6.70711C9.48043 6.89464 9.73478 7 10 7C10.2652 7 10.5196 6.89464 10.7071 6.70711C10.8946 6.51957 11 6.26522 11 6V5C11 4.46957 10.7893 3.96086 10.4142 3.58579C10.0391 3.21071 9.53043 3 9 3H8C7.20435 3 6.44129 3.31607 5.87868 3.87868C5.31607 4.44129 5 5.20435 5 6V11H4C3.46957 11 2.96086 11.2107 2.58579 11.5858C2.21071 11.9609 2 12.4696 2 13V14C1.99996 14.9783 2.23913 15.9417 2.69665 16.8064C3.15417 17.671 3.81618 18.4107 4.625 18.961L4.293 19.293C4.19749 19.3852 4.12131 19.4956 4.0689 19.6176C4.01649 19.7396 3.9889 19.8708 3.98775 20.0036C3.9866 20.1364 4.0119 20.2681 4.06218 20.391C4.11246 20.5138 4.18671 20.6255 4.2806 20.7194C4.3745 20.8133 4.48615 20.8875 4.60905 20.9378C4.73194 20.9881 4.86362 21.0134 4.9964 21.0123C5.12918 21.0111 5.2604 20.9835 5.3824 20.9311C5.50441 20.8787 5.61475 20.8025 5.707 20.707L6.583 19.832C7.037 19.942 7.512 20 8 20H16C16.488 20 16.963 19.942 17.417 19.832L18.293 20.707C18.4816 20.8892 18.7342 20.99 18.9964 20.9877C19.2586 20.9854 19.5094 20.8802 19.6948 20.6948C19.8802 20.5094 19.9854 20.2586 19.9877 19.9964C19.99 19.7342 19.8892 19.4816 19.707 19.293L19.375 18.961C20.1838 18.4107 20.8458 17.671 21.3034 16.8064C21.7609 15.9417 22 14.9783 22 14V13C22 12.4696 21.7893 11.9609 21.4142 11.5858C21.0391 11.2107 20.5304 11 20 11H7V6ZM4 13H20V14C20 15.0609 19.5786 16.0783 18.8284 16.8284C18.0783 17.5786 17.0609 18 16 18H8C6.93913 18 5.92172 17.5786 5.17157 16.8284C4.42143 16.0783 4 15.0609 4 14V13Z"
                  fill="#074873"
                />
              </svg> </span
            >{{ property.bathroom }} Baths</small
          >
        </div>
        <div v-if="property.reception">
          <small class="tw-flex tw-items-center tw-gap-2"
            ><span
              ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.556 18H18.444C19.3871 18 20.2916 17.6254 20.9585 16.9585C21.6254 16.2916 22 15.3871 22 14.444V12C22 11.4696 21.7893 10.9609 21.4142 10.5858C21.0391 10.2107 20.5304 10 20 10C19.4696 10 18.9609 10.2107 18.5858 10.5858C18.2107 10.9609 18 11.4696 18 12V13.2C18 13.4122 17.9157 13.6157 17.7657 13.7657C17.6157 13.9157 17.4122 14 17.2 14H6.8C6.58783 14 6.38434 13.9157 6.23431 13.7657C6.08429 13.6157 6 13.4122 6 13.2V12C6 11.4696 5.78929 10.9609 5.41421 10.5858C5.03914 10.2107 4.53043 10 4 10C3.46957 10 2.96086 10.2107 2.58579 10.5858C2.21071 10.9609 2 11.4696 2 12V14.444C2 15.3871 2.37465 16.2916 3.04153 16.9585C3.70841 17.6254 4.61289 18 5.556 18Z"
                  stroke="#074873"
                  stroke-width="2"
                />
                <path
                  d="M20 10C20 9.07 20 8.606 19.923 8.22C19.7687 7.44401 19.3877 6.73121 18.8282 6.17175C18.2688 5.6123 17.556 5.23132 16.78 5.077C16.394 5 15.93 5 15 5H9C8.07 5 7.606 5 7.22 5.077C6.44401 5.23132 5.73121 5.6123 5.17175 6.17175C4.6123 6.73121 4.23132 7.44401 4.077 8.22C4 8.606 4 9.07 4 10"
                  stroke="#074873"
                  stroke-width="2"
                />
                <path d="M20 19V18M4 19V18" stroke="#074873" stroke-width="2" stroke-linecap="round" />
              </svg> </span
            >{{ property.reception }} Reception</small
          >
        </div>
        <div v-if="property.floor_area">
          <small class="tw-flex tw-items-center tw-gap-2"
            ><span
              ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3 5V19C3 20.103 3.897 21 5 21H19C20.103 21 21 20.103 21 19V5C21 3.897 20.103 3 19 3H5C3.897 3 3 3.897 3 5ZM19.002 19H5V5H19L19.002 19Z"
                  fill="#074873"
                />
                <path d="M15 12H17V7H12V9H15V12ZM12 15H9V12H7V17H12V15Z" fill="#074873" />
              </svg> </span
            >{{ property.floor_area }}</small
          >
        </div>
      </div>
      <button class="n-secondary tw-mt-8">VIEW THIS PROPERTY</button>
      </template>

      <template v-else-if="property.is_locked">
        <p class="tw-py-7 ">
          This is a pre-market property. You need to create an account and register to our property alerts in order to
          view it.
        </p>
        <div class="tw-mt-10 tw-flex tw-gap-x-2">
          <nuxt-link :to="routes.REGISTER" class="n-primary tw-w-fit" :external="true">Register</nuxt-link>
          <nuxt-link
            :to="`${routes.PROPERTY_DETAIL.replace(':propertyId', property.property_profile_id)}#login`"
            class="n-primary tw-w-fit"
            :external="true"
            >Login</nuxt-link
          >
        </div>
      </template>
    </nuxt-link>
  </div>
</template>

<script lang="ts">
import type { PropertyItemComponent } from '~/units/properties/types';
import { ROUTES } from '~/constants/ui.constants';
import { PropertyMixin } from '~/units/properties/mixins/property.mixin';

export default defineNuxtComponent({
  name: 'PropertyListItem',

  mixins: [PropertyMixin],

  props: {
    property: {
      required: true,
      type: Object as PropType<PropertyItemComponent>,
    },

    index: {
      type: Number,
      required: true,
    },

    isMatchInformationHidden: {
      required: false,
      type: Boolean,
      default: false,
    },

    featureCountNumber: {
      required: false,
      type: Number,
      default: 3,
    },

    version: {
      required: false,
      type: String,
      default: 'v1',
    },

    preMarketBlurText: {
      required: false,
      type: String,
    },
  },

  computed: {
    routes() {
      return ROUTES;
    },
  },
});
</script>
